import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { PhoneCall } from 'lucide-react';
import { stripTrailingSlash } from '@/lib/utils';

export default function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (stripTrailingSlash(pathname) === '/contact') return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="md:hidden fixed bottom-0 left-0 right-0 z-40 px-4 pb-4"
          style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 1rem)' }}
        >
          <Link
            to="/contact/"
            data-testid="mobile-sticky-cta"
            className="flex items-center justify-center gap-2 w-full py-4 rounded-full bg-brand-blue text-white font-semibold shadow-[0_0_30px_rgba(var(--c-purple-rgb),0.5)] backdrop-blur-sm"
          >
            <PhoneCall size={18} /> Book a Free Call
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
